import { render } from "./pharmacysidebar.vue?vue&type=template&id=2909f857"
import script from "./pharmacysidebar.vue?vue&type=script&lang=js"
export * from "./pharmacysidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__